import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const ROUTES = {
  LEAD_CONTACT_LIST: 'organization-lead-contact',
  LEAD_CONTACT_CREATE: 'organization-lead-contact-create',
  LEAD_CONTACT_DETAIL: 'organization-lead-contact-detail',
  LEAD_CONTACT_DOCUMENT_LIST: 'organization-lead-contact-documents'
}

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const routes = [
  {
    path: ':orgType/extra-contact/',
    name: ROUTES.LEAD_CONTACT_LIST,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['organization_customercontact_list'],
      requiresAuth: true
    },
    component: () => import('./LeadContactList.vue'),
    children: [
      {
        path: 'create/',
        name: ROUTES.LEAD_CONTACT_CREATE,
        beforeEnter: beforeEnter,
        props: true,
        meta: {
          permissions: ['organization_customercontact_create'],
          requiresAuth: true
        },
        component: () => import('./LeadContactCreate.vue')
      },
      {
        path: ':cntId/',
        name: ROUTES.LEAD_CONTACT_DETAIL,
        beforeEnter: beforeEnter,
        props: true,
        meta: {
          permissions: ['organization_customercontact_retrieve'],
          requiresAuth: true
        },
        component: () => import('./LeadContactDetail.vue'),
        children: [
          {
            path: 'documents/',
            name: ROUTES.LEAD_CONTACT_DOCUMENT_LIST,
            beforeEnter: beforeEnter,
            props: true,
            meta: {
              permissions: ['document_uploaddocument_list'],
              requiresAuth: true
            },
            component: () => import('../../../../document/upload-document/UploadDocumentsList.vue')
          }
        ]
      }
    ]
  }

]

export { routes, ROUTES }
